/* istanbul ignore file: this file does not contain any logic, only factory calls */ import { BaseOptions, createLocalizationFactory } from "@devowl-wp/utils";
// Only needed once per `window`
let FACTORY_MEMO;
function get() {
    return FACTORY_MEMO ? FACTORY_MEMO : FACTORY_MEMO = createLocalizationFactory(BaseOptions.getPureSlug(process.env.slug));
}
const _n = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return get()._n(...args);
};
const _nx = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return get()._nx(...args);
};
const _x = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return get()._x(...args);
};
const __ = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return get().__(...args);
};
const _i = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return get()._i(...args);
};
export { _n, _nx, _x, __, _i };
